import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    component: String,
    props: Object,
  }

  connect() {
    this.renderComponent()
  }

  disconnect() {
    if (window.reactRoots?.[this.element.id]) {
      try {
        window.reactRoots[this.element.id].unmount()
      } catch (e) {
        // Ignore unmount errors
      }
      delete window.reactRoots[this.element.id]
    }
  }

  renderComponent() {
    if (window.renderReactComponent) {
      try {
        window.renderReactComponent(this.componentValue, this.element.id, this.propsValue)
      } catch (error) {
        console.error('React component render failed:', error)
      }
    } else {
      setTimeout(() => this.renderComponent(), 200)
    }
  }
}
